import { render, staticRenderFns } from "./BitrixInstall.vue?vue&type=template&id=5ddc0128&scoped=true"
import script from "./BitrixInstall.vue?vue&type=script&lang=js"
export * from "./BitrixInstall.vue?vue&type=script&lang=js"
import style0 from "./BitrixInstall.vue?vue&type=style&index=0&id=5ddc0128&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddc0128",
  null
  
)

export default component.exports